import { DatePipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, takeWhile, tap, timer } from 'rxjs';

@Component({
	selector: 'app-count-down',
	templateUrl: './count-down.component.html',
	imports: [DatePipe],
})
export class CountDownComponent {
	readonly timerSeconds = input.required<number>();

	readonly timerFinished = output();

	/** Milliseconds left, ticking every second; undefined until the first tick, and the timer completes below 0. */
	protected readonly timeRemaining = toSignal(
		timer(0, 1000).pipe(
			map((n) => (this.timerSeconds() - n) * 1000),
			takeWhile((n) => n >= 0),
			tap({
				complete: () => this.timerFinished.emit(),
			})
		)
	);
}
